import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { constants } from '../constants/constants';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../shared';
import { APIService } from './api.service';


@Injectable({
  providedIn: 'root'
})

export class CmsService {
  serviceEndpoint = constants.serviceEndPoints.contentData;
  serviceConfigurationPoint = constants.serviceEndPoints.dcjConfigurationData;
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

  constructor(private httpClient: HttpClient, private apiService: APIService) {}

  public getContent(): any {
    return this.httpClient.get(this.endPoints.contentDataUrl).toPromise()
    .then(res => res);
  }

  public getCMSData(endpoint: string): any {
    return this.httpClient.get(this.apiService.getURL(endpoint)).toPromise()
    .then(res => res);
  }

}


